<template>
  <div>
    <div v-show="mediafile.sources.length > 0" class="playerWrapper">
      <div :id="`video-${mediafile.id}-player`" class="video-player-wrapper">
        <div class="video-player-container">
          <div class="video-player player">
            <video
              ref="videoPlayer"
              class="video-js"
              width="590"
              height="405"
              tabindex="0"
              :poster="mediafile.poster"
              controls="controls"
              preload="auto"
              autobuffer="false"
              :id="`video-${mediafile.id}`"
              :data-event-label="`video-${mediafile.id}`"
            >
              <source v-for="source in mediafile.sources" :src="source.src" :type="source.type" :label="source.label" ref="source">
              <track v-for="track in mediafile.tracks" :kind="track.kind" :src="track.src">
            </video>
          </div>
        </div>
      </div>
    </div>
    <show-processing type="video" :show="canSeeProcessing" :state="state"></show-processing>

    <transcript
      v-if="mediafile.captions && mediafile.captions.content"
      :transcript="mediafile.captions.content"
      :pdfUrl="mediafile.captions.download_pdf_path" sectionType="Markup">
    </transcript>

  </div>
</template>
<script>

import { initVideoPlayer, destroyVideoPlayer } from 'video/videoJsPlayer'
import ShowProcessing from './show_processing.vue'
import Transcript from "../../tutorial_edit/components/sections/video_transcript.vue"

import $ from 'jquery'

export default {
  name: "VideoPlayer",
  components: {
    ShowProcessing,
    Transcript
  },
  props: {
    mediafile: {
      type: Object
    },
    canEdit: {
      type: Boolean
    }
  },
  computed: {
    state() {
      return this.mediafile.state
    },
    canSeeProcessing() {
      return this.canEdit && this.mediafile.sources.length < 1
    }
  },
  methods: {
    destroyPlayer() {
      const player = $(this.$refs.videoPlayer)

      $('.editable-section-edit', player.parents('.section-wrapper')).on('click', () => {
        destroyVideoPlayer(this.$refs.videoPlayer)
      })
    }
  },
  mounted() {
    initVideoPlayer(this.$refs.videoPlayer)
    this.destroyPlayer()
  },
  beforeUnmount() {
    destroyVideoPlayer(this.$refs.videoPlayer)
  }
}
</script>
